export interface ICoinSelectorMobilePreset {
  algorithmWidthPx: number;
  coinWidthPx: number;
  labelFontSizeRem: number;
  selectFontSizeRem?: number;
  controlGapPx: number;
  singleLineGapPx: number;
}

// Matches the selector dimensions that were used in logged main before refactor.
export const COIN_SELECTOR_MOBILE_PRESET_LOGGED_MAIN: ICoinSelectorMobilePreset =
  {
    algorithmWidthPx: 96,
    coinWidthPx: 94,
    labelFontSizeRem: 0.82,
    controlGapPx: 6,
    singleLineGapPx: 6,
  };

// Compact variant for very narrow mobile screens (e.g. <349px).
export const COIN_SELECTOR_MOBILE_PRESET_NARROW: ICoinSelectorMobilePreset = {
  algorithmWidthPx: 84,
  coinWidthPx: 94,
  labelFontSizeRem: 0.74,
  selectFontSizeRem: 0.74,
  controlGapPx: 4,
  singleLineGapPx: 4,
};
